module.exports = {
	"ha": "vcha",
	"id": 5.2,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for Vancouver Coastal Health by Gender, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 98.57775705292609,
						"dataLabels": {
							"enabled": true,
							"format": "4228",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.00816041035206,
						"dataLabels": {
							"enabled": true,
							"format": "3646",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.43576591280018,
						"dataLabels": {
							"enabled": true,
							"format": "3407",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.56283515971089,
						"dataLabels": {
							"enabled": true,
							"format": "3198",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.08137094893915,
						"dataLabels": {
							"enabled": true,
							"format": "2534",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.24137931034483,
						"dataLabels": {
							"enabled": true,
							"format": "535",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.51724137931035,
						"dataLabels": {
							"enabled": true,
							"format": "496",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.03448275862068,
						"dataLabels": {
							"enabled": true,
							"format": "470",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.44827586206897,
						"dataLabels": {
							"enabled": true,
							"format": "426",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 49.137931034482754,
						"dataLabels": {
							"enabled": true,
							"format": "285",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -1.422242947073915,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.765373699148531,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.55512890839276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.134429116524798,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -20.76297686053784,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.758620689655171,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.289719626168223,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.241935483870963,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.361702127659576,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -33.098591549295776,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Men<br>n=4289"
			},
			{
				"x": 9,
				"text": "Women<br>n=580"
			}
		],
		"dataTable": {
			"Men": [
				4289,
				4228,
				3646,
				3407,
				3198,
				2534
			],
			"Women": [
				580,
				535,
				496,
				470,
				426,
				285
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_2.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_2.json
// module id = 303
// module chunks = 0